import { render, staticRenderFns } from "./Header-Chain.vue?vue&type=template&id=14f3c1b0&scoped=true"
import script from "./Header-Chain.vue?vue&type=script&lang=js"
export * from "./Header-Chain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f3c1b0",
  null
  
)

export default component.exports